<template>
  <b-card>
    <b-row>
      <b-col lg="4">
        <b-form-group
          id="input-group-29"
          :label="$t('edu_programs.edu_programs')"
          label-for="input-29"
        >
          <b-form-select
            v-model="eduProgramId"
            :options="eduPrograms"
            text-field="name"
            value-field="id"
            @change="changeEduPrograms(eduProgram)"
          /> </b-form-group
      ></b-col>
      <b-col lg="4">
        <b-form-group
          id="input-group-29"
          :label="$t('edu_courses.edu_courses')"
          label-for="input-29"
        >
          <b-form-select
            v-model="course"
            :options="courses"
            text-field="name"
            value-field="id"
            @change="changeCourses()"
          /> </b-form-group
      ></b-col>
      <b-col lg="4">
        <b-form-group
          id="input-group-29"
          :label="$t('edu_contents.edu_contents')"
          label-for="input-29"
        >
          <b-form-select
            v-model="eduContent"
            :options="eduContents"
            text-field="name"
            value-field="id"
            @change="selectSemester()"
          /> </b-form-group
      ></b-col>
      <b-col lg="4">
        <b-form-group
          id="input-group-29"
          :label="$t('rooms.rooms')"
          label-for="input-29"
        >
          <b-form-select
            v-model="room"
            :options="rooms"
            text-field="name"
            value-field="id"
            @change="selectSemester()"
          /> </b-form-group
      ></b-col>
      <b-col lg="4">
        <b-form-group
          id="input-group-29"
          :label="$t('edu_programs.semester')"
          label-for="input-29"
        >
          <b-form-select
            v-model="semester"
            :options="semesters"
            text-field="name"
            value-field="id"
            @change="selectSemester(semester)"
          /> </b-form-group
      ></b-col>
    </b-row>

    <div class="row">
      <div class="col-md-12 overflow-auto">
        <b-table :stacked="($mobile==1)" 
          ref="table"
          class="vuetable"
          sort-by="id"
          sort-desc.sync="false"
          :current-page="currentPage"
          :fields="bootstrapTable.fields"
          :items="dataProvider"
        >
          <template #cell(edit)="data">
            <b-button @click="share(data.item)" variant="outline-primary">
              {{ $t("edu_contents.share") }}
            </b-button>
          </template>
          <template #cell(online_class_count)="data">
            <b-badge
              v-if="data.item.share_count > 1"
              variant="info"
              class="badge-glow"
            >
              {{ $t("edu_contents.shareLecture") }}
            </b-badge>
            <b-badge v-else variant="primary" class="badge-glow">
              {{ $t("edu_contents.normalLecture") }}
            </b-badge>
          </template>
        </b-table>
        <b-spinner v-if="load" type="grow" label="Loading..." class="loading" />

        <hr />
        <b-pagination
          v-model="currentPage"
          align="right"
          class="dataTables_paginate paging_simple_numbers pagination-warning"
          :total-rows="totalRows"
          :per-page="perPage"
        >
          <template v-slot:next-text>
            <i class="fas fa-angle-left" />
          </template>
          <template v-slot:prev-text>
            <i class="fas fa-angle-right" />
          </template>
          <template v-slot:first-text>
            <i class="fas fa-step-forward" />
          </template>
          <template v-slot:last-text>
            <i class="fas fa-step-backward" />
          </template>
        </b-pagination>

        <!-- end of table -->
      </div>
      <!-- end of col -->
    </div>
    <!-- end of row -->
    <b-modal
      ref="modal-primary"
      ok-only
      :ok-title="$t('site.add')"
      @ok="save"
      modal-class="modal-primary"
      size="lg"
      centered
    >
      <b-row>
        <b-col lg="3">
          <b-form-group
            id="input-group-29"
            :label="$t('edu_programs.edu_programs')"
            label-for="input-29"
          >
            <b-form-select
              v-model="eduProgramNew"
              :options="eduCoursesData.edu_programs"
              text-field="name"
              value-field="id"
              @change="changeNewEduPrograms(eduProgramNew)"
            /> </b-form-group
        ></b-col>
        <b-col lg="3">
          <b-form-group
            id="input-group-29"
            :label="$t('rooms.rooms')"
            label-for="input-29"
          >
            <b-form-select
              v-model="roomN"
              :options="roomsNew"
              text-field="name"
              value-field="id"
              @change="selectSemester(semester)"
            /> </b-form-group
        ></b-col>
        <b-col lg="3">
          <b-form-group
            id="input-group-29"
            :label="$t('edu_programs.semester')"
            label-for="input-29"
          >
            <b-form-select
              v-model="semestreN"
              :options="semesterNew"
              text-field="name"
              value-field="id"
            /> </b-form-group
        ></b-col>
        <b-col lg="3">
          <b-button
            @click="addShare()"
            block
            variant="outline-primary"
            style="margin-top: 20px"
          >
            {{ $t("site.add") }}
          </b-button>
        </b-col>
      </b-row>

      <hr />
      <b-row>
        <b-table :stacked="($mobile==1)"  :items="onlineClass" :fields="onlineClassfields">
          <template #cell(room_id)="data">
            {{ getRoom(data) }}
          </template>
          <template #cell(semester_num)="data">
            {{ getSemester(data) }}
          </template>
          <template #cell(edit)="data">
            <button
              class="btn btn-icon btn-danger btn-sm"
              @click="deleteItem(data)"
            >
              <i class="fa fa-trash" />
            </button>
          </template>
        </b-table>
        <b-spinner
          v-if="loadshare"
          type="grow"
          label="Loading..."
          class="loading"
        />
      </b-row>
    </b-modal>
  </b-card>
</template>

<script>
import controller from "@/Controllers/EduContentRoomController";
import Edu_schemesController from "@/Controllers/Edu_schemesController";
import EduProgramsController from "@/Controllers/EduProgramsController";
import EduCoursesController from "@/Controllers/EduCoursesController";

export default {
  name: "EduContentRoomDataTable",
  props: ["items", "editItem"],
  data() {
    return {
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          {
            key: "get_edu_content.name",
            label: this.$i18n.t("edu_contents.edu_contents"),
            sortable: true,
          },
          {
            key: "get_room.name",
            label: this.$i18n.t("rooms.rooms"),
            sortable: true,
          },
          {
            key: "semester.name",
            label: this.$i18n.t("edu_programs.semester"),
            sortable: true,
          },
          {
            key: "start_in",
            label: this.$i18n.t("edu_contents.start_in"),
            sortable: true,
          },
          {
            key: "online_class_count",
            label: "",
            sortable: true,
          },
          { key: "edit", label: this.$i18n.t("site.action"), sortable: false },
        ],
      },
      onlineClassfields: [
        {
          key: "get_room.edu_program.name",
          label: this.$i18n.t("edu_programs.edu_programs"),
          sortable: true,
        },
        {
          key: "get_room.name",
          label: this.$i18n.t("rooms.rooms"),
          sortable: true,
        },
        {
          key: "semester.name",
          label: this.$i18n.t("edu_programs.semester"),
          sortable: true,
        },

        { key: "edit", label: this.$i18n.t("site.action"), sortable: false },
      ],
      data: {},
      selectAll: false,
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      eduPrograms: [],
      semesters: [],
      semesterNew: [],
      semester: 0,
      semestreN: 0,
      rooms: [],
      roomsNew: [],
      room: 0,
      roomN: 0,
      courses: [],
      course: 0,
      eduProgramNew: 0,
      onlineClass: [],
      loadshare: false,
      eduProgramId: 0,
      eduProgram: {},
      eduContents: [],
      eduContent: 0,
      eduCoursesData: {},
      edu_programNew: {},
      eduContentRoom: {},
    };
  },
  async created() {
    this.eduPrograms = await new EduProgramsController().GetAll({
      with: ["semester", "rooms", "courses.eduContents"],
    });
  },
  methods: {
    changeEduPrograms() {
      this.eduProgram = this.eduPrograms.find((a) => a.id == this.eduProgramId);

      this.courses = this.eduProgram.courses.filter((a) => a.flixable == 0);
      this.rooms = this.eduProgram.rooms;
      this.semesters = this.eduProgram.semester;
    },
    changeCourses() {
      const course = this.courses.find((a) => a.id == this.course);
      this.eduContents = course.edu_contents;
    },
    // selectSemester(semester) {
    async selectSemester(semester) {
      if (this.room == 0) return;
      // if (!semester) return;

      // this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    async share(item) {
      this.loadshare = true;
      this.onlineClass = [];
      this.eduCoursesData = {};
      this.$refs["modal-primary"].show();
      this.eduContentRoom = item;
      this.onlineClass = await new controller().GetAll({
        filter: "online_class_id|" + item.online_class_id,
        with: ["getRoom.eduProgram", "semester"],
      });
      console.log(item);
      this.eduCoursesData = await new EduCoursesController().Show(
        item.get_edu_content.edu_course_id,
        {
          with: ["eduPrograms.rooms", "eduPrograms.semester"],
        }
      );
      this.loadshare = false;
    },

    changeNewEduPrograms(id) {
      this.semesterNew = [];
      this.roomsNew = [];
      const edu_program = this.eduCoursesData.edu_programs.find(
        (a) => a.id == id
      );
      this.edu_programNew = edu_program;
      this.semesterNew = edu_program.semester;
      this.roomsNew = edu_program.rooms;
    },
    deleteItem(data) {
      const findIndex = this.onlineClass.findIndex(
        (a) =>
          a.room_id == data.item.room_id &&
          a.semester_num == data.item.semester_num
      );
      this.onlineClass.splice(findIndex, 1);
    },
    addShare() {
      const find = this.onlineClass.find(
        (a) => a.room_id == this.roomN && a.semester_num == this.semestreN
      );
      const edu_program = this.eduCoursesData.edu_programs.find(
        (a) => a.id == this.eduProgramNew
      );

      const sa = this.semesterNew.find((a) => a.id == this.semestreN);
      const roomsNew = this.roomsNew.find((a) => a.id == this.roomN);
      let get_room = {
        edu_program: { name: edu_program.name },
        name: roomsNew.name,
      };
      let semester = { name: sa.name };
      if (!find)
        this.onlineClass.push({
          room_id: this.roomN,
          edu_content_id: this.eduContentRoom.edu_content_id,
          start_in: this.eduContentRoom.start_in,
          end_in: this.eduContentRoom.end_in,
          semester_num: this.semestreN,
          online_class_id: this.eduContentRoom.online_class_id,
          get_room: get_room,
          semester: semester,
        });

      console.log(this.onlineClass);
    },
    save() {
      new Edu_schemesController().getShareContents({
        online_class_id: this.eduContentRoom.online_class_id,
        data: this.onlineClass,
      });
    },

    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await new controller().GetAll(this.apiParamsConverter());
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data = data.data;
      this.load = false;
      return data.data;
    },
    apiParamsConverter() {
      const apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }
      //  roomId: this.room,
      //   semester_num: semester,
      let eduContent = "";
      if (this.eduContent != 0) {
        eduContent = `&&edu_content_id|${this.eduContent}`;
      }
      // let room_id = "";
      // if (this.room != 0) {
      //   room_id = `room_id|${this.room}`;
      // }

      let semester_num = "";
      if (this.semester != 0) {
        semester_num = `&&semester_num|${this.semester}`;
      }
      apiParams.filter = `room_id|${this.room}` + eduContent + semester_num;
      apiParams.with = ["getRoom", "getEduContent", "semester"];
      apiParams.withCount = ["share"];
      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.$refs.table.refresh();
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        console.log(this.data);
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
    // deleteItem(data) {
    //   new controller().Delete(data.item.id, this.$refs.table);
    // },
    // multiDelete() {
    //   new controller().Delete(0, this.recordIds, this.$refs.table);
    // },
  },
};
</script>
